<template>
  <el-container style="width: 100%">
    <el-header>
      <el-button round @click="createClick">{{generateCustomizeString('add')}}</el-button>
    </el-header>
    <el-table :data="brandData" tooltip-effect="dark" style="width: 100%">

      <el-table-column prop="display_name" :label="generateCustomizeString('navigateName')">
      </el-table-column>

      <el-table-column prop="sort_by" :label="generateCustomizeString('sortWeight')">
      </el-table-column>

      <el-table-column prop="created_at" :label="generateCustomizeString('createAt')">
      </el-table-column>

      <el-table-column prop="is_show" :label="generateCustomizeString('bannerActivity')">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_show === 1" type="success" close-transition>
            {{generateCustomizeString('moduleReady')}}
          </el-tag>
          <el-tag v-else type="info" close-transition>
            {{generateCustomizeString('moduleWaitForReview')}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" :label="generateCustomizeString('operate')" width="180">
        <template slot-scope="scope">
          <el-button @click="editClick(scope.row)" type="text" size="small">{{generateCustomizeString('edit')}}</el-button>
          <el-button @click="deleteClick(scope.row)" type="text" size="small">{{generateCustomizeString('delete')}}</el-button>
          <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :append-to-body="true">
            <span>{{ generateCustomizeString('confirmDelete') }}</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">{{ generateCustomizeString('cancel') }}</el-button>
              <el-button type="primary" @click="deleteBrandModule">{{ generateCustomizeString('confirm')}}</el-button>
            </span>
          </el-dialog>
        </template>
      </el-table-column>
    </el-table>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:15px;">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="15" layout="total, prev, pager, next" :total="currentTotal">
      </el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'PcGoodsModule',
  data() {
    return {
      brandData: [],
      selectDeleteId: 0,
      currentPage: 1,
      currentTotal: 0,
      dialogVisible: false
    }
  },
  methods: {
    generateCustomizeString,
    deleteClick(row) {
      this.selectDeleteId = row.id
      this.dialogVisible = true
    },
    deleteBrandModule() {
      if (this.selectDeleteId === 0) return
      request({
        url: 'cms-category-item/' + this.selectDeleteId,
        method: 'delete'
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('deletedSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('deleteFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('deleteFailed'))
        })
        .finally(() => {
          this.fetchData(this.currentPage)
          this.dialogVisible = false
          this.selectDeleteId = 0
        })
    },
    createClick() {
      this.$router.push({
        name: 'CreateBrandModule',
        params: {
          cms_home_category_id: this.$route.params.cms_home_category_id
        }
      })
    },
    editClick(row) {
      this.$router.push({
        name: 'EditBrandModule',
        params: {
          cms_home_category_id: this.$route.params.cms_home_category_id,
          categoryId: row.id
        }
      })
    },
    handleCurrentChange(val) {
      this.fetchData(val)
    },
    fetchData(page) {
      if (this.fetchLoding) return
      this.fetchLoding = true

      request({
        url:
          '/cms-category-items?type=4&cms_home_category_id=' +
          this.$route.params.cms_home_category_id,
        method: 'get',
        params: {
          page: page
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta
          this.brandData = data
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.fetchLoding = false
        })
    }
  },
  created: function() {
    this.fetchData()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #efefef;
  // color: #333;
  text-align: left;
  line-height: 60px;
}
</style>
